module.exports = __webpack_public_path__ + "img/kategori-img-6.13e7f609.png";